<template>
    <div class="calc-preview-table">
        <div class="calc-preview-table__head">
            <div>
                {{ $t('§calc.step3.table.flexibility') }}
                <CalcTooltip>{{ $t('§calc.step3.table.flexibility_tooltip') }}</CalcTooltip>
            </div>
            <div>{{ $t('§calc.step3.table.high') }}</div>
            <div>{{ $t('§calc.step3.table.medium') }}</div>
            <div>{{ $t('§calc.step3.table.low') }}</div>
        </div>
        <div class="calc-preview-table__row">
            <span class="calc-preview-table__label">
                {{ $t('§calc.step3.table.monthly_base_fee') }}
            </span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.monthlyBaseFee.high) }}</span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.monthlyBaseFee.medium) }}</span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.monthlyBaseFee.low) }}</span>
        </div>
        <div class="calc-preview-table__row">
            <span class="calc-preview-table__label">{{ $t(billingLabel) }}</span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.perUsage.high) }}</span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.perUsage.medium) }}</span>
            <span class="calc-preview-table__value">{{ displayAsCurrency(result.perUsage.low) }}</span>
        </div>
    </div>
</template>

<script>
import CalcTooltip from './CalcTooltip.vue'

export default {
    name: 'CalcPreviewTable',

    components: { CalcTooltip },

    props: {
        result: {
            type: Object,
            required: true,
            validator: (v) =>
                v && typeof v === 'object' && v.monthlyBaseFee && v.perUsage,
        },
        billingLabel: {
            type: String,
            required: true,
        },
    },
}
</script>

<style scoped>
.calc-preview-table {
    border: 1px solid var(--calc-line);
    border-radius: 16px;
    overflow: hidden;
    background: white;
    margin-top: 38px;
}

.calc-preview-table__head {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    background: var(--calc-bg-soft);
    border-bottom: 1px solid var(--calc-line);
    padding: 16px 20px;
    font-size: 14px;
    letter-spacing: -0.02em;
    color: var(--calc-ink);
}

.calc-preview-table__head > div {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(4, 15, 15, 0.4);
}

.calc-preview-table__head > div:not(:first-child) {
    justify-content: flex-start;
}

.calc-preview-table__row {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    padding: 16px 20px;
    align-items: center;
    min-height: 58px;
}

.calc-preview-table__row + .calc-preview-table__row {
    border-top: 0;
}

.calc-preview-table__label {
    font-size: 14px;
    letter-spacing: -0.02em;
    color: rgba(4, 15, 15, 0.4);
}

.calc-preview-table__value {
    text-align: left;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: -0.02em;
    color: var(--calc-ink);
    font-family: 'TWK Lausanne', 'Inter', sans-serif;
}

@media (max-width: 760px) {
    .calc-preview-table__head {
        padding: 14px 12px;
        font-size: 12px;
    }
    .calc-preview-table__row {
        padding: 14px 12px;
    }
    .calc-preview-table__label {
        font-size: 12px;
    }
    .calc-preview-table__value {
        font-size: 16px;
    }
}
</style>
